// Tiny 14-day bar sparkline. Single accent hue, baseline-anchored, no axes/legend.
// Bars scale to the array's own max; zero days render nothing. All-zero histories
// collapse to a muted em-dash so an empty curator doesn't draw a phantom baseline.
const WIDTH = 64;
const HEIGHT = 20;
const GAP = 1;

export function ActivitySparkline({ activity }: { activity: number[] }) {
  const total = activity.reduce((sum, count) => sum + count, 0);
  const max = Math.max(...activity, 0);
  const barWidth = (WIDTH - GAP * (activity.length - 1)) / activity.length;

  if (total === 0) {
    return <span className="text-gray-400 dark:text-zinc-500">—</span>;
  }

  return (
    <svg
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      className="h-5 w-16"
      role="img"
      preserveAspectRatio="none"
    >
      <title>{`${total} reviews in last 14 days`}</title>
      {activity.map((count, index) => {
        if (count === 0) return null;
        const barHeight = Math.max((count / max) * HEIGHT, 1);
        return (
          <rect
            key={index}
            x={index * (barWidth + GAP)}
            y={HEIGHT - barHeight}
            width={barWidth}
            height={barHeight}
            className="fill-blue-500 dark:fill-blue-400"
          />
        );
      })}
    </svg>
  );
}
